import React from "react";
import Spinner from "../loaders/spinner/Spinner";

interface IButton {
    children?: React.ReactNode;
    loading?: boolean;
    callback: () => (any | void);
    className?: string;
}

const Button: React.FC<IButton> = ({
    children,
    loading = false,
    callback,
    className,
}) => {
    const handleCallback = () => {
        if (!loading) {
            callback();
        }
    }
    
    return (
        <button onClick={handleCallback} className={"select-none bg-red hover:opacity-80 text-[15px] uppercase leading-[18px] font-semibold text-white py-[9px] px-[18px] rounded-[4px]" + (!!className ? (" " + className) : "")}>
            {
                !loading &&
                children
            }
            {
                loading &&
                <Spinner color="#FFFFFF" />
            }
        </button>
    );
}

export default Button;